import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import { host } from '../../App';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import { Button, Menu, Dropdown, Row } from 'antd';
import { Link } from "react-router-dom";
import "./OtherExpenses.css";

function Other_Expenses(props) {
  var token = (window.localStorage.getItem("acessToken"));
  const user = JSON.parse(window.localStorage.getItem("Name"));
  var [Date1, setDate1] = useState(new Date());
  const [Date2, setDate2] = useState(Date1.toISOString().slice(0, 10));
  const [part_dataset, setpart_dataset] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  var [Customers, setCustomers] = useState([]);
  var length = 0;

  const [data, setData] = useState([
    { Invoice_No: '', Invoice_Date: '', Item_Description: '', Supplier: '', Category: '', Qty: '', Unit: '', Unit_Cost: '', Currency: '', ETA: '', Notes: '' },
    { Invoice_No: '', Invoice_Date: '', Item_Description: '', Supplier: '', Category: '', Qty: '', Unit: '', Unit_Cost: '', Currency: '', ETA: '', Notes: '' },
    { Invoice_No: '', Invoice_Date: '', Item_Description: '', Supplier: '', Category: '', Qty: '', Unit: '', Unit_Cost: '', Currency: '', ETA: '', Notes: '' },
    { Invoice_No: '', Invoice_Date: '', Item_Description: '', Supplier: '', Category: '', Qty: '', Unit: '', Unit_Cost: '', Currency: '', ETA: '', Notes: '' },
    { Invoice_No: '', Invoice_Date: '', Item_Description: '', Supplier: '', Category: '', Qty: '', Unit: '', Unit_Cost: '', Currency: '', ETA: '', Notes: '' }
  ]);


  // Hook to update the date as today's date
  useEffect(() => {
    var timer = setInterval(() => setDate1(new Date()), 10)
    return function cleanup() {
      clearInterval(timer)
    }
  });

  useEffect(() => {
    Axios.get(`https://` + host + `/api/get/part_dataset/${token}`).then((data) => {
      setpart_dataset(data.data);
    });
  }, []);
  useEffect(() => {
    Axios.get(`https://` + host + `/api/Other_Expenses/suppliers/${token}`).then((data) => {
      setCustomers(data.data)
    });
  }, [])
  useEffect(() => {
    const newData = data.map((line) => ({ ...line, Date: Date2 }));
    setData(newData);
  }, [Date2])

  const submitValue = (e, index) => {
    const newData = [...data];
    newData[index].Item_No = e.target.value;
    newData[index].Supplier = (part_dataset.find((x) => x.Item_No === e.target.value).Supplier);
    newData[index].Item_Description = part_dataset.find((x) => x.Item_No === e.target.value).Item_Description;
    setData(newData);
  }

  const addLines = () => {
    if (data.length < 15) {
      const newData = [...data];
      for (let i = 0; i < 5; i++) {
        newData.push({ Invoice_No: '', Invoice_Date: '', Item_Description: '', Supplier: '', Category: '', Qty: '', Unit: '', Unit_Cost: '', Currency: '', ETA: '', Notes: '' });
      }
      setData(newData);
    } else {
      window.alert("Lines Reached maximum limit")
    }
  }
  const handleLogout = () => {
    window.localStorage.removeItem("acessToken");
    window.localStorage.removeItem("Name");
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    props.history.push('/');
  }
  const userMenu = (
    <Menu>
      <Menu.Item key="logout">
        <a onClick={handleLogout} href="/">
          <LogoutOutlined />
          Logout
        </a>
      </Menu.Item>
    </Menu>
  );

  const submitdata = () => {
    const filteredData = [];
    data.forEach(item => {
      if (
        item.Invoice_No &&
        item.Invoice_Date
      ) {
        const newData = [
          item.Invoice_No,
          item.Invoice_Date,
          item.Item_Description,
          item.Supplier,
          item.Category,
          item.Qty,
          item.Unit,
          item.Unit_Cost,
          item.Currency,
          item.ETA,
          item.Notes,
          item.CUSTOMS,
          item.SHIPPING
        ];

        filteredData.push(newData);
      }
      length = filteredData.length;
    });

    setIsLoading(true);

    setTimeout(() => {
      Axios.post(`https://` + host + `/supplychain/Other_Expenses`, { filteredData })
        .then((response) => {
          if (response.status === 200) {
            window.alert(response.data.message);
            setIsLoading(false);
            window.location.reload();

          }
        })
        .catch(error => {
          window.alert("Error Occured")
          setIsLoading(false);
        });
    }, 2000);

    console.log(filteredData);
    // window.location.reload(false);
  }
  const toggleShipping = (e, index) => {
    const newData = [...data];
    newData[index].SHIPPING = newData[index].SHIPPING === "Yes" ? "No" : "Yes";
    setData(newData);
  };
  const toggleCustoms = (e, index) => {
    const newData = [...data];
    newData[index].CUSTOMS = newData[index].CUSTOMS === "Yes" ? "No" : "Yes";
    setData(newData);
  };
  return (
    <div className="oePage">
      <div className="oeCard">
        <div className="oeHeader">
          <div>
            <div className="oeTitle">OTHER EXPENSES</div>
            <div className="oeSub">Add invoice and expense lines</div>
          </div>
          <button onClick={addLines} className="btn btn-success oeAddBtn">Add Row</button>
        </div>

        <div className="oeTableWrap">
          <table className="table table-bordered oeTable">
            <tbody>
              <tr>
                <th>Invoice No</th>
                <th>Invoice Date</th>
                <th>Item Description</th>
                <th>Supplier</th>
                <th>Category</th>
                <th>Qty</th>
                <th>Unit</th>
                <th>Unit Cost</th>
                <th>Currency</th>
                <th>ETA</th>
                <th>CUSTOMS</th>
                <th>SHIPPING</th>
                <th>Notes</th>
              </tr>
              {data.map((line, index) => (
                <tr>
                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const newData = [...data];

                        newData[index].Invoice_No = e.target.value;

                        setData(newData);
                      }}
                      placeholder="Invoice No"
                    />
                  </td>
                  <td>
                    <input
                      type="date"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const newData = [...data];

                        newData[index].Invoice_Date = e.target.value;

                        setData(newData);
                      }}
                      placeholder="ETA"
                      name="Invoice Date"
                      required
                    />
                  </td>
                  <td class="col-2">
                    <input
                      type="text"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const newData = [...data];

                        newData[index].Item_Description = e.target.value;

                        setData(newData);
                      }}
                      placeholder="Item Description"

                      required
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const newData = [...data];

                        newData[index].Supplier = e.target.value;

                        setData(newData);
                      }}
                      placeholder="Supplier"
                      list='Suppliers'
                    />
                    <datalist id="Suppliers">
                      <option></option>
                      {Customers.map(x => {
                        return <option>{x.Supplier}</option>
                      })}
                    </datalist>
                  </td>
                  <td >
                    <input
                      type="text"
                      className="form-control form-rounded"
                      placeholder="Category"
                      list="category"
                      onChange={(e) => {
                        const newData = [...data];

                        newData[index].Category = e.target.value;

                        setData(newData);
                      }}
                    />
                    <datalist id='category'>
                      <option>IT SERVICES</option>
                      <option>HR</option>
                      <option>MAINTENANCE</option>
                      <option>MAINTAINENANCE</option>
                      <option>DUTY AND BROKERAGE</option>
                      <option>OTHER</option>
                      <option>ENGINEERING</option>
                      <option>DISPOSAL</option>
                      <option>UTILITIES</option>
                      <option>SUPPLIES</option>
                      <option>BROKERAGE</option>
                      <option>OFFICE</option>
                      <option>UPHOLSTERY</option>
                      <option>PRODUCTION</option>
                      <option>TRANSPORTATION</option>

                    </datalist>
                  </td>


                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only numbers
                        if (!/^\d*\.?\d*$/.test(value)) {
                          alert("Numbers only");
                          return;
                        }

                        const newData = [...data];
                        newData[index].Qty = value;
                        setData(newData);
                      }}
                      placeholder="Qty"
                    />
                  </td>
                  <td >
                    <input
                      type="text"
                      className="form-control form-rounded"
                      placeholder="Unit"
                      list="unit"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Unit = e.target.value;
                        setData(newData);
                      }}
                    />
                    <datalist id='unit'>
                      <option>Each</option>
                      <option>Feet</option>
                      <option>FT</option>
                      <option>GAL</option>
                      <option>SHEET</option>
                      <option>KG</option>
                      <option>LBS</option>
                      <option>METER</option>
                      <option>PACK</option>
                      <option>PC</option>
                      <option>ROLL</option>
                      <option>YARDS</option>
                    </datalist>
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      placeholder="Unit Cost"
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only numbers and decimal
                        if (!/^\d*\.?\d*$/.test(value)) {
                          alert("Numbers only");
                          return;
                        }

                        const newData = [...data];
                        newData[index].Unit_Cost = value;
                        setData(newData);
                      }}
                    />
                  </td>
                  <td >
                    <input
                      type="select"
                      className="form-control form-rounded"
                      placeholder="Currency"
                      list='currency'
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Currency = e.target.value;
                        setData(newData);
                      }}
                    />
                    <datalist id='currency'>
                      <option>CAD</option>
                      <option>USD</option>

                    </datalist>
                  </td>

                  <td>
                    <input
                      type="date"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].ETA = e.target.value;

                        setData(newData);
                      }}
                      placeholder="ETA"
                      name="target"
                      required
                    />
                  </td>
                  <td>
                    <button
                      className="btn btn-light"
                      onClick={(e) => toggleCustoms(e, index)}
                    >
                      {data[index].CUSTOMS}
                    </button></td>
                  <td><button
                    className="btn btn-light"
                    onClick={(e) => toggleShipping(e, index)}
                  >
                    {data[index].SHIPPING}
                  </button>
                  </td>
                  <td>
                    <input
                      type="textarea"
                      className="form-control form-rounded"
                      placeholder="Notes"
                      name="Supervisor_notes"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Notes = e.target.value;
                        setData(newData);
                      }}

                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="oeFooter">
          <button onClick={submitdata} className="btn btn-primary oeSubmitBtn">Submit</button>
        </div>

        {isLoading ? (
          <div className="overlay oeOverlay">
            <div className="loading-container">
              <div className="loading-dots">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
              <p className='loading'>Submitting</p>
            </div>

          </div>
        ) : null}
      </div>
    </div>
  );
}

export default Other_Expenses;